module.exports = __webpack_public_path__ + "static/media/k400at8000047_processed_rsz.d0663c54.jpg";